// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2ThMM","approved":"Status_approved__22Bwq","rejected":"Status_rejected__1hcbz","expired":"Status_expired__YjvFE","label":"Status_label__2KdIq"};